module.exports = __webpack_public_path__ + "img/purpleTxt.d69fa63b.png";